import { modalStore } from '@/stores/modal.store';

const WithdrawSuccess = () => {
    const { toggleModal, setData } = modalStore((state) => state);

    function close() {
        toggleModal();
        setData({});
    }

    return (
        <div className="flex flex-col items-center text-center gap-6 min-w-[360px] max-md:min-w-0 py-2">
            <div
                className="w-16 h-16 grid place-items-center rounded-full"
                style={{
                    background:
                        'radial-gradient(circle at 50% 35%, rgba(58,205,177,0.30) 0%, rgba(58,205,177,0.08) 60%, transparent 100%)',
                    boxShadow:
                        '0 0 0 1px rgba(58,205,177,0.35), 0 10px 26px rgba(43,184,155,0.30)',
                }}
            >
                <svg
                    viewBox="0 0 24 24"
                    className="w-7 h-7 stroke-[#3acdb1] fill-none [stroke-width:2.4] [stroke-linecap:round] [stroke-linejoin:round]"
                >
                    <path d="M5 12.5l4.5 4.5L19 7" />
                </svg>
            </div>

            <p className="text-[14px] text-text_2 max-w-[320px] leading-relaxed">
                Trade offer sent. Please confirm it on Steam.
            </p>

            <button
                onClick={close}
                className="w-full inline-flex items-center justify-center gap-2.5 py-3.5 rounded-fl text-[13px] font-bold tracking-[0.10em] uppercase text-white hover:-translate-y-0.5 hover:brightness-110 transition-all"
                style={{
                    background: 'linear-gradient(180deg, #3acdb1, #2bb89b)',
                    boxShadow:
                        '0 10px 24px rgba(43,184,155,0.40), inset 0 1px 0 rgba(255,255,255,0.30)',
                }}
            >
                <svg
                    viewBox="0 0 24 24"
                    className="w-4 h-4 stroke-current fill-none [stroke-width:2.2] [stroke-linecap:round] [stroke-linejoin:round]"
                >
                    <path d="M5 12.5l4.5 4.5L19 7" />
                </svg>
                Accept trade offer
            </button>
        </div>
    );
};

export default WithdrawSuccess;
